<template>
  <article :class="[$style.container]">
    <div :class="$style.content" v-html="content" />

    <div :class="$style.footer">
      <button :class="$style.moreBtn" @click="onViewMore">查看全部<i class="el-icon-arrow-right" /></button>
    </div>
  </article>
</template>
<script>
import { defineComponent, useRouter } from "@nuxtjs/composition-api";

export default defineComponent({
	name: "ProductDetailAgreement",
	props: {
		content: String
	},
	setup() {
		const router = useRouter();
		function onViewMore() {
			const { href } = router.resolve({
				path: "/product/automation/requirements-agreements"
			});
			window.open(href, "_blank");
		}
		return {
			onViewMore
		};
	}
});
</script>
<style lang="scss" module>
.container h1, .container h2, .container h3, .container h4, .container h5, .container h6 {
  margin-bottom: 0.75rem;
}
.container {
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.container a {
  pointer-events: none;
}
.container h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.container h2 {
  font-size: 1.625rem;
}
.container h3 {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.container h4 {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.container ul, .container ol {
  list-style-position: outside;
  margin-bottom: 1.25rem;
  margin-top: 0px;
  padding-left: 1.25rem;
}
.container ul {
  list-style-type: disc;
}
.container p {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.content {
  max-height: 5rem;
  overflow: hidden;
}
.footer {
  text-align: center;
}
.moreBtn {
  margin-top: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(31, 157, 139, var(--tw-text-opacity));
}
</style>